import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import IdealStudio from "../../../../core/editor/main";
import { isSlide, isContainedView } from "../../../../common/utils";
import { ID_PREFIX_BOX } from "../../../../common/constants";
import { randomPositionGenerator } from "../../clipboard/clipboard.utils";
import { createBox } from "../../../../common/common_tools";
import getMediaBoxSize from "../../../utils/getMediaBoxSize";
import AppModal from "../../common/modal/AppModal";

const rooturl =
  process.env.REACT_APP_LIBRARY_ROOT_URL ||
  "https://cloud.aideapro.ai/middlewareblob/common/aideapro/";

export const ICONS = [
  {
    id: "file-76022043530279",
    url: rooturl + "library/Sekiller/baklava.png",
    name: "yanKare",
    keywords: "eşkenar dörtgen, yan kare",
    mimetype: "image/png",
  },
  {
    id: "file-63474127011920",
    url: rooturl + "library/Sekiller/daire.png",
    name: "daire",
    keywords: "daire,yuvarlak",
    mimetype: "image/png",
  },
  {
    id: "file-44235675184286",
    url: rooturl + "library/Sekiller/dikbirdikdortgen.png",
    name: "dikDikdörtgen",
    keywords: "dik dikdörtgen",
    mimetype: "image/png",
  },
  {
    id: "file-17037883773158",
    url: rooturl + "library/Sekiller/dikdortgen.png",
    name: "dikdörtgen",
    keywords: "dikdörtgen",
    mimetype: "image/png",
  },
  {
    id: "file-3029124482062",
    url: rooturl + "library/Sekiller/kare.png",
    name: "kare",
    keywords: "kare",
    mimetype: "image/png",
  },
  {
    id: "file-95483271709135",
    url: rooturl + "library/Sekiller/ucgen.png",
    name: "üçgen",
    keywords: "üçgen",
    mimetype: "image/png",
  },

  // ikonlar
  {
    id: "file-20620473410637",
    url: rooturl + "library/ikonlar/accept_10948134.svg",
    name: "accept_10948134.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-31240752274879",
    url: rooturl + "library/ikonlar/alert_11357138.svg",
    name: "alert_11357138.svg",
    keywords: "ünlem,uyarı,exclamation,warning",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-11434658320671",
    url: rooturl + "library/ikonlar/alert_2058160.svg",
    name: "alert_2058160.svg",
    keywords: "ünlem,uyarı,bildirim,exclamation,warning,notification",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-84067145742603",
    url: rooturl + "library/ikonlar/badge_12692626.svg",
    name: "badge_12692626.svg",
    keywords: "başarı,rozet,kurdele,madalya,achievement,badge,ribbon,medal",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-54328868503639",
    url: rooturl + "library/ikonlar/badge_13450502.svg",
    name: "badge_13450502.svg",
    keywords: "başarı,rozet,kurdele,madalya,achievement,badge,ribbon,medal",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-4188613216906",
    url: rooturl + "library/ikonlar/cancel_190406.svg",
    name: "cancel_190406.svg",
    keywords: "çarpı,yanlış,iptal,cross,wrong,cancel",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-58828525972795",
    url: rooturl + "library/ikonlar/check-mark_12503776.svg",
    name: "check-mark_12503776.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-86894711418874",
    url: rooturl + "library/ikonlar/check-mark_5290058.svg",
    name: "check-mark_5290058.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-78907898542672",
    url: rooturl + "library/ikonlar/check-mark_5290075.svg",
    name: "check-mark_5290075.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-73566535670772",
    url: rooturl + "library/ikonlar/check-mark_5290076.svg",
    name: "check-mark_5290076.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-95264802636030",
    url: rooturl + "library/ikonlar/check-mark_5290081.svg",
    name: "check-mark_5290081.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-57420564380618",
    url: rooturl + "library/ikonlar/checked_190411.svg",
    name: "checked_190411.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-8852664591209",
    url: rooturl + "library/ikonlar/checked_753344.svg",
    name: "checked_753344.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-82891436321977",
    url: rooturl + "library/ikonlar/checked_9709605.svg",
    name: "checked_9709605.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-92967454199871",
    url: rooturl + "library/ikonlar/check_12483830.svg",
    name: "check_12483830.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-69688237641820",
    url: rooturl + "library/ikonlar/check_12484055.svg",
    name: "check_12484055.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-59495522932526",
    url: rooturl + "library/ikonlar/check_12901779.svg",
    name: "check_12901779.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-33193756380751",
    url: rooturl + "library/ikonlar/check_13423930.svg",
    name: "check_13423930.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-53477347641598",
    url: rooturl + "library/ikonlar/check_1828640.svg",
    name: "check_1828640.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-88631034174184",
    url: rooturl + "library/ikonlar/check_3472620.svg",
    name: "check_3472620.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-530717546260",
    url: rooturl + "library/ikonlar/check_5610944.svg",
    name: "check_5610944.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-35220857741344",
    url: rooturl + "library/ikonlar/check_6785304.svg",
    name: "check_6785304.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-50585905948576",
    url: rooturl + "library/ikonlar/check_9068908.svg",
    name: "check_9068908.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-63533265658434",
    url: rooturl + "library/ikonlar/click_1536577.svg",
    name: "click_1536577.svg",
    keywords: "tıklama,imleç,click,cursor",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-52480694382448",
    url: rooturl + "library/ikonlar/coin_11280638.svg",
    name: "coin_11280638.svg",
    keywords: "başarı,rozet,kurdele,yıldız,achievement,badge,ribbon,star",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-19005623413745",
    url: rooturl + "library/ikonlar/confetti_4213475.svg",
    name: "confetti_4213475.svg",
    keywords: "başarı,kutlama,konfetisuccess,celebration,confetti",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-82712235504030",
    url: rooturl + "library/ikonlar/crisis-communication_13068634.svg",
    name: "crisis-communication_13068634.svg",
    keywords: "ünlem,uyarı,exclamation,warning",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-98917811775028",
    url: rooturl + "library/ikonlar/crisis_10468096.svg",
    name: "crisis_10468096.svg",
    keywords: "ünlem,uyarı,duyuru,exclamation,warning,announcement",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-54198998423584",
    url: rooturl + "library/ikonlar/decrease_12813677.svg",
    name: "decrease_12813677.svg",
    keywords: "ok,kırmızı ok,düşüş,azalma,arrow,red arrow,decline,decrease",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-64613484256333",
    url: rooturl + "library/ikonlar/decrease_6067145.svg",
    name: "decrease_6067145.svg",
    keywords: "ok,kırmızı ok,düşüş,azalma,arrow,red arrow,decline,decrease",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-27605567182397",
    url: rooturl + "library/ikonlar/delete_5610967.svg",
    name: "delete_5610967.svg",
    keywords: "çarpı,yanlış,iptal,cross,wrong,cancel",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-21595237731975",
    url: rooturl + "library/ikonlar/favourite_8906905.svg",
    name: "favourite_8906905.svg",
    keywords: "yıldız, turuncu yıldız,başarı,star,orange star,success",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-60906705663568",
    url: rooturl + "library/ikonlar/fireworks_1054436.svg",
    name: "fireworks_1054436.svg",
    keywords: "başarı,kutlama,yıldız,success,celebration,star",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-50427243321906",
    url: rooturl + "library/ikonlar/hypothesis_12641404.svg",
    name: "hypothesis_12641404.svg",
    keywords:
      "soru,anket,soru işareti,doğru,yanlış,seçenek,question,survey,question mark,true,false,option",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-53829148751008",
    url: rooturl + "library/ikonlar/information_10015217.svg",
    name: "information_10015217.svg",
    keywords: "bilgi,bilgilendirme,info,information",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-36982003517049",
    url: rooturl + "library/ikonlar/information_13470579.svg",
    name: "information_13470579.svg",
    keywords: "ünlem,uyarı,duyuru,exclamation, warning, announcement",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-17685047173040",
    url: rooturl + "library/ikonlar/information_9195785.svg",
    name: "information_9195785.svg",
    keywords: "bilgi,bilgilendirme,info,information",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-15895219364371",
    url: rooturl + "library/ikonlar/info_13330616.svg",
    name: "info_13330616.svg",
    keywords: "bilgi,bilgilendirme,info,information",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-61799306185166",
    url: rooturl + "library/ikonlar/info_189664.svg",
    name: "info_189664.svg",
    keywords: "bilgi,bilgilendirme,info,information",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-13639562513672",
    url: rooturl + "library/ikonlar/info_7309678.svg",
    name: "info_7309678.svg",
    keywords: "bilgi,bilgilendirme,info,information",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-89017991155643",
    url: rooturl + "library/ikonlar/interview_13264256.svg",
    name: "interview_13264256.svg",
    keywords: "soru,cevap,soru işareti,konuşma balonu,question,answer,question mark,speech bubble",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-9889881571492",
    url: rooturl + "library/ikonlar/like_3670153.svg",
    name: "like_3670153.svg",
    keywords: "beğeni,onay,başarı,el,like,approval,success,hand",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-3110471399938",
    url: rooturl + "library/ikonlar/medal_12559152.svg",
    name: "medal_12559152.svg",
    keywords: "başarı,rozet,kurdele,madalya,yıldız,achievement,badge,ribbon,medal,star",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-4431567242500",
    url: rooturl + "library/ikonlar/medal_610333.svg",
    name: "medal_610333.svg",
    keywords: "başarı,rozet,kurdele,madalya,yıldız,achievement,badge,ribbon,medal,star",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-40678852632770",
    url: rooturl + "library/ikonlar/megaphone_13470641.svg",
    name: "megaphone_13470641.svg",
    keywords: "megafon,duyuru,bildiri,megaphone,announcement,declaration",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-50311434410033",
    url: rooturl + "library/ikonlar/megaphone_13492366.svg",
    name: "megaphone_13492366.svg",
    keywords: "megafon,duyuru,bildiri,megaphone,announcement,declaration",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-28535353244325",
    url: rooturl + "library/ikonlar/megaphone_13492774.svg",
    name: "megaphone_13492774.svg",
    keywords: "megafon,duyuru,bildiri,megaphone,announcement,declaration",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-9731323985140",
    url: rooturl + "library/ikonlar/megaphone_595990.svg",
    name: "megaphone_595990.svg",
    keywords: "megafon,duyuru,bildiri,megaphone,announcement,declaration",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-26095889840118",
    url: rooturl + "library/ikonlar/megaphone_9019234.svg",
    name: "megaphone_9019234.svg",
    keywords: "megafon,duyuru,bildiri,megaphone,announcement,declaration",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-22749723758471",
    url: rooturl + "library/ikonlar/mindfulness_13003408.svg",
    name: "mindfulness_13003408.svg",
    keywords: "çak,el,anlaşma,başarı,kutlama,high-five,hand,deal,success,celebration",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-64547777154612",
    url: rooturl + "library/ikonlar/motivation_12657338.svg",
    name: "motivation_12657338.svg",
    keywords: "el,başarı,kutlama,motivasyon,yıldız,hand,success,celebration,motivation,star",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-65524943854357",
    url: rooturl + "library/ikonlar/motivation_13423366.svg",
    name: "motivation_13423366.svg",
    keywords: "el,başarı,kutlama,motivasyon,yıldız,hand,success,celebration,motivation,star",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-23956753671860",
    url: rooturl + "library/ikonlar/multiply_399274.svg",
    name: "multiply_399274.svg",
    keywords: "çarpı,yanlış,iptal,cross,wrong,cancel",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-36364537191738",
    url: rooturl + "library/ikonlar/next_3925158.svg",
    name: "next_3925158.svg",
    keywords: "ileri,ok,mavi,mavi ok,geçiş,forward,arrow,blue,blue arrow,transition",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-76526206626528",
    url: rooturl + "library/ikonlar/party-popper_7626666.svg",
    name: "party-popper_7626666.svg",
    keywords: "başarı,kutlama,konfeti,success,celebration,confetti",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-75986992508605",
    url: rooturl + "library/ikonlar/plus_1828817.svg",
    name: "plus_1828817.svg",
    keywords: "artı,plus",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-41024193963963",
    url: rooturl + "library/ikonlar/plus_4315609.svg",
    name: "plus_4315609.svg",
    keywords: "artı,plus",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-39694123146559",
    url: rooturl + "library/ikonlar/police_12621060.svg",
    name: "police_12621060.svg",
    keywords: "başarı,rozet,madalya,yıldız,achievement,badge,medal,star",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-99702556860395",
    url: rooturl + "library/ikonlar/protection_12824236.svg",
    name: "protection_12824236.svg",
    keywords:
      "başarı,rozet,madalya,tik,koruma,güvenli,achievement,badge,medal,tick,protection,secure",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-32040476361225",
    url: rooturl + "library/ikonlar/protection_4891646.svg",
    name: "protection_4891646.svg",
    keywords:
      "başarı,rozet,madalya,tik,koruma,güvenli,achievement,badge,medal,tick,protection,secure",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-8788729889530",
    url: rooturl + "library/ikonlar/quality-control_13439660.svg",
    name: "quality-control_13439660.svg",
    keywords: "başarı,rozet,madalya,tik,achievement,badge,medal,tick",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-61844708429947",
    url: rooturl + "library/ikonlar/quality_7608293.svg",
    name: "quality_7608293.svg",
    keywords: "tik,doğru,onay,kabul,büyüteç,tick,correct,check,acceptance,magnifying glass",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-79031434496415",
    url: rooturl + "library/ikonlar/question-mark_5726470.svg",
    name: "question-mark_5726470.svg",
    keywords: "soru işareti,soru,question mark,question",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-67575314931439",
    url: rooturl + "library/ikonlar/question-mark_5726678.svg",
    name: "question-mark_5726678.svg",
    keywords: "soru işareti,soru,question mark,question",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-81898656237374",
    url: rooturl + "library/ikonlar/question_189665.svg",
    name: "question_189665.svg",
    keywords: "soru işareti,soru,question mark,question",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-80977196038698",
    url: rooturl + "library/ikonlar/question_7887097.svg",
    name: "question_7887097.svg",
    keywords: "soru işareti,soru,question mark,question",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-54971428321869",
    url: rooturl + "library/ikonlar/quote_6314351.svg",
    name: "quote_6314351.svg",
    keywords: "tırnak işareti,quotes",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-52432793699837",
    url: rooturl + "library/ikonlar/rating_13332871.svg",
    name: "rating_13332871.svg",
    keywords: "tik,doğru,onay,kabul,yıldız,tick,correct,approval,acceptance,star",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-3579745384338",
    url: rooturl + "library/ikonlar/research_13479836.svg",
    name: "research_13479836.svg",
    keywords: "ünlem,uyarı,büyüteç,exclamation,warning,magnifying glass",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-77440904415822",
    url: rooturl + "library/ikonlar/reward_12570265.svg",
    name: "reward_12570265.svg",
    keywords: "başarı,rozet,madalya,yıldız.kurdele,achievement,badge,medal,star,ribbon",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-10667625383297",
    url: rooturl + "library/ikonlar/right-arrow_10949407.svg",
    name: "right-arrow_10949407.svg",
    keywords: "ok,ileri,geri,beyaz ok,yeşil,yuvarlak,arrow,forward,back,white arrow,green,round",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-2666676101351",
    url: rooturl + "library/ikonlar/right-arrow_892666.svg",
    name: "right-arrow_892666.svg",
    keywords: "ok,ileri,geri,mavi ok,mavi,arrow,forward,back,blue arrow,blue",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-72167223155781",
    url: rooturl + "library/ikonlar/shield_12902030.svg",
    name: "shield_12902030.svg",
    keywords: "tik,doğru,onay,kabul,güvenli,tick,correct,approval,acceptance,secure",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-8175282879070",
    url: rooturl + "library/ikonlar/siren_11227389.svg",
    name: "siren_11227389.svg",
    keywords: "ünlem,uyarı,siren,duyuru,önemli,exclamation,warning,siren,announcement,important",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-85698173156496",
    url: rooturl + "library/ikonlar/siren_12961356.svg",
    name: "siren_12961356.svg",
    keywords: "ünlem,uyarı,siren,duyuru,önemli,exclamation,warning,siren,announcement,important",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-83782364607948",
    url: rooturl + "library/ikonlar/siren_1331428.svg",
    name: "siren_1331428.svg",
    keywords: "ünlem,uyarı,siren,duyuru,önemli,exclamation,warning,siren,announcement,important",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-82070671566488",
    url: rooturl + "library/ikonlar/speaker_12895496.svg",
    name: "speaker_12895496.svg",
    keywords: "megafon,duyuru,bildiri,megaphone,announcement,declaration",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-86792507400132",
    url: rooturl + "library/ikonlar/speaker_7152226.svg",
    name: "speaker_7152226.svg",
    keywords: "megafon,duyuru,bildiri,megaphone,announcement,declaration",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-99233021844894",
    url: rooturl + "library/ikonlar/star_13439362.svg",
    name: "star_13439362.svg",
    keywords: "yıldız, turuncu yıldız,başarı,star,orange star,success",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-9820111556387",
    url: rooturl + "library/ikonlar/star_187628.svg",
    name: "star_187628.svg",
    keywords: "yıldız, turuncu yıldız,başarı,star,orange star,success",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-44290014217045",
    url: rooturl + "library/ikonlar/star_7408613.svg",
    name: "star_7408613.svg",
    keywords: "yıldız, turuncu yıldız,başarı,star,orange star,success",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-49042078613966",
    url: rooturl + "library/ikonlar/stop-sign_6834466.svg",
    name: "stop-sign_6834466.svg",
    keywords: "dur,yasak,uyarı,stop,forbidden,warning",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-64004943333627",
    url: rooturl + "library/ikonlar/thumbs-up_2954885.svg",
    name: "thumbs-up_2954885.svg",
    keywords:
      "el,başarı,kutlama,motivasyon,yıldız,onay,hand,success,celebration,motivation,star,approval",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-82047347897268",
    url: rooturl + "library/ikonlar/trophy_1021202.svg",
    name: "trophy_1021202.svg",
    keywords: "ödül,başarı,yıldız,kupa,kutlama,award,achievement,star,trophy,celebration",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-34729906021601",
    url: rooturl + "library/ikonlar/trophy_2827957.svg",
    name: "trophy_2827957.svg",
    keywords: "ödül,başarı,kupa,kutlama,award,achievement,trophy,celebration",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-98268837726012",
    url: rooturl + "library/ikonlar/verified_7641727.svg",
    name: "verified_7641727.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-82995374222538",
    url: rooturl + "library/ikonlar/verify_11042305.svg",
    name: "verify_11042305.svg",
    keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-45813666003330",
    url: rooturl + "library/ikonlar/warning_2797387.svg",
    name: "warning_2797387.svg",
    keywords: "ünlem,uyarı,exclamation,warning",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-3308987799256",
    url: rooturl + "library/ikonlar/warning_4201973.svg",
    name: "warning_4201973.svg",
    keywords: "ünlem,uyarı,exclamation,warning",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-86537212449930",
    url: rooturl + "library/ikonlar/warning_595067.svg",
    name: "warning_595067.svg",
    keywords: "ünlem,uyarı,exclamation,warning",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-83634758651602",
    url: rooturl + "library/ikonlar/warning_752755.svg",
    name: "warning_752755.svg",
    keywords: "ünlem,uyarı,exclamation,warning",
    mimetype: "image/svg+xml",
  },

  // part 2
  {
    id: "file-89818232575950",
    url: rooturl + "library/ikonlar/agreement_3188314.svg",
    name: "agreement_3188314.svg",
    keywords: "anlaşma,el sıkışma,el,hand,agreement,handshake",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-7591030347055",
    url: rooturl + "library/ikonlar/agreement_988107.svg",
    name: "agreement_988107.svg",
    keywords: "anlaşma,el sıkışma,el,hand,agreement,handshake",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-91915765598847",
    url: rooturl + "library/ikonlar/analytics_12176905.svg",
    name: "analytics_12176905.svg",
    keywords: "grafik,analitik,graphics, analytics",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-90457213832801",
    url: rooturl + "library/ikonlar/bar-chart_610128.svg",
    name: "bar-chart_610128.svg",
    keywords: "grafik,analitik,graphics, analytics",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-12076714237510",
    url: rooturl + "library/ikonlar/book-stack_3389081.svg",
    name: "book-stack_3389081.svg",
    keywords: "kitap,kitaplar,book,books",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-45405597404510",
    url: rooturl + "library/ikonlar/book_2232688.svg",
    name: "book_2232688.svg",
    keywords: "kitap,kitaplar,book,books",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-94667741416764",
    url: rooturl + "library/ikonlar/book_9479086.svg",
    name: "book_9479086.svg",
    keywords: "kitap,book",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-12467005480329",
    url: rooturl + "library/ikonlar/business-strategy_10327438.svg",
    name: "business-strategy_10327438.svg",
    keywords: "grafik,analitik,graphics, analytics",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-4376517633529",
    url: rooturl + "library/ikonlar/calendar_10691802.svg",
    name: "calendar_10691802.svg",
    keywords: "takvim,calendar",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-28447079129755",
    url: rooturl + "library/ikonlar/calendar_3143636.svg",
    name: "calendar_3143636.svg",
    keywords: "takvim,calendar",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-9304638962289",
    url: rooturl + "library/ikonlar/checklist_11891157.svg",
    name: "checklist_11891157.svg",
    keywords: "liste,anket,survey,checklist",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-72555304884849",
    url: rooturl + "library/ikonlar/children_3885025.svg",
    name: "children_3885025.svg",
    keywords:
      "karakter,insan,çocuk,kız,erkek,girl,boy,children,child,person,people,character,woman,man",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-29476079006199",
    url: rooturl + "library/ikonlar/classroom_906175.svg",
    name: "classroom_906175.svg",
    keywords:
      "ders,öğretmen,öğrenci,sunum,insan,insanlar,course,teacher,student,presentation,person,people",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-20402147772184",
    url: rooturl + "library/ikonlar/clipboard_13340952.svg",
    name: "clipboard_13340952.svg",
    keywords: "grafik,analitik,graphics, analytics",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-93278129322546",
    url: rooturl + "library/ikonlar/collaborate_7829192.svg",
    name: "collaborate_7829192.svg",
    keywords: "iş birliği,el,puzzle,collaborate,hand",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-61865372212575",
    url: rooturl + "library/ikonlar/comments_2190552.svg",
    name: "comments_2190552.svg",
    keywords: "yorum,iletişim,comment,communication",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-351319626178",
    url: rooturl + "library/ikonlar/comment_2593491.svg",
    name: "comment_2593491.svg",
    keywords: "yorum,iletişim,comment,communication",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-61837912933094",
    url: rooturl + "library/ikonlar/community_11531327.svg",
    name: "community_11531327.svg",
    keywords: "topluluk,insan,insanlar,bağlantı,community,person,people,connection",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-41780103205006",
    url: rooturl + "library/ikonlar/compliant_4252296.svg",
    name: "compliant_4252296.svg",
    keywords: "kitap,adalet,hukuk,book,justice,law",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-5761950232178",
    url: rooturl + "library/ikonlar/contact-form_3157914.svg",
    name: "contact-form_3157914.svg",
    keywords: "liste,anket,survey,checklist,form",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-59934327192775",
    url: rooturl + "library/ikonlar/conversation_6208405.svg",
    name: "conversation_6208405.svg",
    keywords: "yorum,iletişim,comment,communication",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-49701437368718",
    url: rooturl + "library/ikonlar/customer-service_870175.svg",
    name: "customer-service_870175.svg",
    keywords: "call center,çağrı merkezi,iletişim,communication",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-40377025969664",
    url: rooturl + "library/ikonlar/dashboard_1991103.svg",
    name: "dashboard_1991103.svg",
    keywords: "grafik,analitik,graphics, analytics",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-79568107231702",
    url: rooturl + "library/ikonlar/data-analysis_2110161.svg",
    name: "data-analysis_2110161.svg",
    keywords: "grafik,analitik,graphics, analytics",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-39155538597590",
    url: rooturl + "library/ikonlar/data-collection_3270865.svg",
    name: "data-collection_3270865.svg",
    keywords: "belge,document",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-97684896576666",
    url: rooturl + "library/ikonlar/delete_3221897.svg",
    name: "delete_3221897.svg",
    keywords: "silme,sil,çöp kutusu,delete,clear,temizleme,bin",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-49990666093765",
    url: rooturl + "library/ikonlar/documentation_12238166.svg",
    name: "documentation_12238166.svg",
    keywords: "belge,document",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-4355837478215",
    url: rooturl + "library/ikonlar/educational-video_13972594.svg",
    name: "educational-video_13972594.svg",
    keywords: "kitap,kitaplar,book,books,eğitim,education",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-36489875788172",
    url: rooturl + "library/ikonlar/education_3976631.svg",
    name: "education_3976631.svg",
    keywords: "kitap,kitaplar,book,books,eğitim,education,video",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-84665794830478",
    url: rooturl + "library/ikonlar/family_2219802.svg",
    name: "family_2219802.svg",
    keywords: "topluluk,insan,insanlar,aile,community,person,people,family",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-21821546423985",
    url: rooturl + "library/ikonlar/files_7515634.svg",
    name: "files_7515634.svg",
    keywords: "belge,document",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-10240696342824",
    url: rooturl + "library/ikonlar/flags_1706517.svg",
    name: "flags_1706517.svg",
    keywords: "başarı,kutlama,konfeti,success,celebration,confetti,yıldız,star,bayrak,flag",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-71190801258487",
    url: rooturl + "library/ikonlar/folder_2014997.svg",
    name: "folder_2014997.svg",
    keywords: "belge,document,dosya,file",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-12946006239403",
    url: rooturl + "library/ikonlar/frustrated_6000952.svg",
    name: "frustrated_6000952.svg",
    keywords: "emoji,kızgın,angry",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-42321261302670",
    url: rooturl + "library/ikonlar/good-feedback_9732828.svg",
    name: "good-feedback_9732828.svg",
    keywords: "başarı,kutlama,success,celebration,yıldız,star",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-52303282288404",
    url: rooturl + "library/ikonlar/graduated_2231642.svg",
    name: "graduated_2231642.svg",
    keywords: "başarı,success,mezuniyet,kep,diploma,graduation,cap",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-96782078630782",
    url: rooturl + "library/ikonlar/graduation_2997322.svg",
    name: "graduation_2997322.svg",
    keywords: "başarı,success,mezuniyet,kep,diploma,graduation,cap,kitap,book",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-59620074577580",
    url: rooturl + "library/ikonlar/group_1357616.svg",
    name: "group_1357616.svg",
    keywords: "topluluk,insan,insanlar,community,person,people",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-1295406640676",
    url: rooturl + "library/ikonlar/hairstyle_363098.svg",
    name: "hairstyle_363098.svg",
    keywords: "insan,kadın,person,woman",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-23178209072037",
    url: rooturl + "library/ikonlar/headset_427665.svg",
    name: "headset_427665.svg",
    keywords: "call center,çağrı merkezi,iletişim,communication",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-14925864648921",
    url: rooturl + "library/ikonlar/history_4215285.svg",
    name: "history_4215285.svg",
    keywords: "geçmiş,belge,saat,history,document,time",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-16226692179080",
    url: rooturl + "library/ikonlar/increasing_5329510.svg",
    name: "increasing_5329510.svg",
    keywords: "grafik,analitik,graphics, analytics",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-4159898091864",
    url: rooturl + "library/ikonlar/information_7887083.svg",
    name: "information_7887083.svg",
    keywords: "ünlem,uyarı,exclamation,warning",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-55019509533869",
    url: rooturl + "library/ikonlar/information_9474482.svg",
    name: "information_9474482.svg",
    keywords: "bilgi,bilgilendirme,info,information",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-89395561433250",
    url: rooturl + "library/ikonlar/insurance_1833835.svg",
    name: "insurance_1833835.svg",
    keywords: "belge,document,onay,approval",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-41626435497352",
    url: rooturl + "library/ikonlar/interaction_2177286.svg",
    name: "interaction_2177286.svg",
    keywords: "etkileşim,tıklama,el,interaction,click,hand",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-75624223795212",
    url: rooturl + "library/ikonlar/ipad_644425.svg",
    name: "ipad_644425.svg",
    keywords: "telefon,phone,tablet,uygulama,app",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-47528018319386",
    url: rooturl + "library/ikonlar/iphone_644458.svg",
    name: "iphone_644458.svg",
    keywords: "telefon,phone,tablet,uygulama,app",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-82245566844785",
    url: rooturl + "library/ikonlar/job_10485136.svg",
    name: "job_10485136.svg",
    keywords: "belge,document,onay,approval",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-30927051440358",
    url: rooturl + "library/ikonlar/laptop-screen_2888701.svg",
    name: "laptop-screen_2888701.svg",
    keywords: "bilgisayar,computer",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-33209998788341",
    url: rooturl + "library/ikonlar/laptop_5205106.svg",
    name: "laptop_5205106.svg",
    keywords: "bilgisayar,oyun,ayarlar,computer,game,settings ",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-6163964811871",
    url: rooturl + "library/ikonlar/leadership_860430.svg",
    name: "leadership_860430.svg",
    keywords:
      "lider,başarı,yükseliş,insan,insanlar,bayrak,leadership,success,rise,person,perople,flag",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-41512189225255",
    url: rooturl + "library/ikonlar/letter_1027530.svg",
    name: "letter_1027530.svg",
    keywords: "belge,document",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-8576329313472",
    url: rooturl + "library/ikonlar/like_6729850.svg",
    name: "like_6729850.svg",
    keywords: "başarı,beğeni,el,baş parmak,success,like,hand,thumbs up",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-5839818998151",
    url: rooturl + "library/ikonlar/manager_122491.svg",
    name: "manager_122491.svg",
    keywords: "insan,kadın,person,woman",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-45301912119957",
    url: rooturl + "library/ikonlar/manager_4205906.svg",
    name: "manager_4205906.svg",
    keywords: "insan,erkek,person,man",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-65556723798810",
    url: rooturl + "library/ikonlar/man_3001758.svg",
    name: "man_3001758.svg",
    keywords: "insan,erkek,person,man",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-19721123167804",
    url: rooturl + "library/ikonlar/man_4086679.svg",
    name: "man_4086679.svg",
    keywords: "insan,erkek,person,man",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-4284396373106",
    url: rooturl + "library/ikonlar/marketing_8227799.svg",
    name: "marketing_8227799.svg",
    keywords: "megafon,duyuru,bildiri,hedef,megaphone,announcement,declaration,goal",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-22300406758891",
    url: rooturl + "library/ikonlar/meeting_7185630.svg",
    name: "meeting_7185630.svg",
    keywords:
      "topluluk,insan,insanlar,bağlantı,community,person,people,connection,toplantı,meeting",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-48204331609832",
    url: rooturl + "library/ikonlar/news_741867.svg",
    name: "news_741867.svg",
    keywords: "megafon,duyuru,bildiri,haber,megaphone,announcement,declaration,news",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-37915397290871",
    url: rooturl + "library/ikonlar/note_4371099.svg",
    name: "note_4371099.svg",
    keywords: "belge,document,not,note",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-21222968811569",
    url: rooturl + "library/ikonlar/parents_2173907.svg",
    name: "parents_2173907.svg",
    keywords: "insan,erkek,person,man,kadın,woman,ebeveyn,parent",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-488818746009",
    url: rooturl + "library/ikonlar/party_2274543.svg",
    name: "party_2274543.svg",
    keywords: "başarı,kutlama,success,celebration,parti,party",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-18780084215667",
    url: rooturl + "library/ikonlar/password_2665311.svg",
    name: "password_2665311.svg",
    keywords: "şifre,güvenlik,password,security",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-5742553417875",
    url: rooturl + "library/ikonlar/pc_9097601.svg",
    name: "pc_9097601.svg",
    keywords: "bilgisayar,computer",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-70211498372422",
    url: rooturl + "library/ikonlar/podcast_1312585.svg",
    name: "podcast_1312585.svg",
    keywords: "mikrofon,kayıt,ses,müzik,microphone,recording,sound,music",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-44221562281522",
    url: rooturl + "library/ikonlar/presentation_1436664.svg",
    name: "presentation_1436664.svg",
    keywords: "ders,öğretmen,sunum,insan,course,teacher,presentation,person",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-55228631361515",
    url: rooturl + "library/ikonlar/profits_609179.svg",
    name: "profits_609179.svg",
    keywords: "grafik,analitik,graphics, analytics",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-18307699258792",
    url: rooturl + "library/ikonlar/programming_6062646.svg",
    name: "programming_6062646.svg",
    keywords: "bilgisayar,computer,yazılım,programming",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-54801185487147",
    url: rooturl + "library/ikonlar/protection_11629426.svg",
    name: "protection_11629426.svg",
    keywords: "güvenlik,koruma,security,protection",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-7181701691608",
    url: rooturl + "library/ikonlar/protest_3160069.svg",
    name: "protest_3160069.svg",
    keywords:
      "topluluk,insan,insanlar,bağlantı,community,person,people,connection,toplantı,meeting,protesto,protest",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-20452649410943",
    url: rooturl + "library/ikonlar/quiz_3874176.svg",
    name: "quiz_3874176.svg",
    keywords: "belge,document,quiz",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-12352371194448",
    url: rooturl + "library/ikonlar/rating_4143195.svg",
    name: "rating_4143195.svg",
    keywords: "başarı,beğeni,success,like,rating,değerlendirme",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-45506823829115",
    url: rooturl + "library/ikonlar/report_11176296.svg",
    name: "report_11176296.svg",
    keywords: "grafik,analitik,graphics, analytics",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-65605204451554",
    url: rooturl + "library/ikonlar/sales-funnel_6467640.svg",
    name: "sales-funnel_6467640.svg",
    keywords: "grafik,analitik,graphics, analytics",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-32260136667745",
    url: rooturl + "library/ikonlar/search-book_13972584.svg",
    name: "search-book_13972584.svg",
    keywords: "başarı,success,mezuniyet,kep,diploma,graduation,cap,kitap,book",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-78341244743844",
    url: rooturl + "library/ikonlar/seo_1055645.svg",
    name: "seo_1055645.svg",
    keywords: "belge,document,arama,search",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-37599778722175",
    url: rooturl + "library/ikonlar/social-media_2065203.svg",
    name: "social-media_2065203.svg",
    keywords: "beğeni,like,sosyal medya,social media",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-8668837402616",
    url: rooturl + "library/ikonlar/software_3950815.svg",
    name: "software_3950815.svg",
    keywords: "bilgisayar,computer,yazılım,programming",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-5743811289615",
    url: rooturl + "library/ikonlar/stack-books_5832416.svg",
    name: "stack-books_5832416.svg",
    keywords: "kitap,kitaplar,book,books,eğitim,education",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-3264095288246",
    url: rooturl + "library/ikonlar/staff_10857085.svg",
    name: "staff_10857085.svg",
    keywords:
      "topluluk,insan,insanlar,bağlantı,community,person,people,connection,toplantı,meeting",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-39039061879613",
    url: rooturl + "library/ikonlar/stars_3266390.svg",
    name: "stars_3266390.svg",
    keywords: "başarı,kutlama,success,celebration,yıldız,star",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-4114686115982",
    url: rooturl + "library/ikonlar/star_616489.svg",
    name: "star_616489.svg",
    keywords: "başarı,kutlama,success,celebration,yıldız,star",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-34297633645273",
    url: rooturl + "library/ikonlar/statistics_2920349.svg",
    name: "statistics_2920349.svg",
    keywords: "grafik,analitik,graphics, analytics",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-54309308124630",
    url: rooturl + "library/ikonlar/stock_2422792.svg",
    name: "stock_2422792.svg",
    keywords: "grafik,analitik,graphics, analytics",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-2796835648888",
    url: rooturl + "library/ikonlar/successful_13431223.svg",
    name: "successful_13431223.svg",
    keywords: "grafik,analitik,graphics, analytics",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-39249498266720",
    url: rooturl + "library/ikonlar/support_2268705.svg",
    name: "support_2268705.svg",
    keywords: "call center,çağrı merkezi,iletişim,communication",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-31521108860476",
    url: rooturl + "library/ikonlar/surveyor_3593636.svg",
    name: "surveyor_3593636.svg",
    keywords: "liste,anket,survey,checklist",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-74052827096039",
    url: rooturl + "library/ikonlar/tablet_3616856.svg",
    name: "tablet_3616856.svg",
    keywords: "tablet,telefon,telephone",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-92639778396223",
    url: rooturl + "library/ikonlar/teacher_1048950.svg",
    name: "teacher_1048950.svg",
    keywords: "ders,öğretmen,sunum,insan,course,teacher,presentation,person,kadın,woman",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-29152236464410",
    url: rooturl + "library/ikonlar/teacher_9721084.svg",
    name: "teacher_9721084.svg",
    keywords: "ders,öğretmen,sunum,insan,course,teacher,presentation,person,erkek,man",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-58234323846442",
    url: rooturl + "library/ikonlar/teamwork_4474452.svg",
    name: "teamwork_4474452.svg",
    keywords:
      "topluluk,insan,insanlar,bağlantı,community,person,people,connection,toplantı,meeting",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-18988675497474",
    url: rooturl + "library/ikonlar/team_476863.svg",
    name: "team_476863.svg",
    keywords:
      "topluluk,insan,insanlar,bağlantı,community,person,people,connection,toplantı,meeting",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-98093704193413",
    url: rooturl + "library/ikonlar/test_1205526.svg",
    name: "test_1205526.svg",
    keywords: "liste,anket,survey,checklist,test",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-78694583113290",
    url: rooturl + "library/ikonlar/test_4838858.svg",
    name: "test_4838858.svg",
    keywords: "liste,anket,survey,checklist,test",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-82087162876007",
    url: rooturl + "library/ikonlar/thank-you_5359966.svg",
    name: "thank-you_5359966.svg",
    keywords: "başarı,success,bayrak,flag,teşekkür,thank you",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-14998782651394",
    url: rooturl + "library/ikonlar/united_1534959.svg",
    name: "united_1534959.svg",
    keywords: "takım,teamwork,el,hand",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-52734698601137",
    url: rooturl + "library/ikonlar/ux_1055666.svg",
    name: "ux_1055666.svg",
    keywords: "bilgisayar,computer,yazılım,programming,tasarım,design",
    mimetype: "image/svg+xml",
  },
  {
    id: "file-11489199385791",
    url: rooturl + "library/ikonlar/win_2374909.svg",
    name: "win_2374909.svg",
    keywords: "başarı,success,yıldız,star,kazanma,win",
    mimetype: "image/svg+xml",
  },

  // OKLAR
  {
    id: "file-2896016739880",
    url: rooturl + "library/Oklar/ok1.png",
    name: "Yeşil Ok",
    keywords: "yeşil,ok,green,arrow, yeşil ok, green arrow",
    mimetype: "image/png",
  },
  {
    id: "file-59895768940814",
    url: rooturl + "library/Oklar/ok2.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-47995088040298",
    url: rooturl + "library/Oklar/ok3.png",
    name: "Pembe Ok",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok, noktalı, dotted",
    mimetype: "image/png",
  },
  {
    id: "file-66350284040308",
    url: rooturl + "library/Oklar/ok4.png",
    name: "Mavi Ok2",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-90651436827775",
    url: rooturl + "library/Oklar/ok5.png",
    name: "Sarı Ok",
    keywords: "sarı,turuncu,ok,sarı ok,turuncu ok,yellow,orange,yellow arrow,orange arrow,arrow",
    mimetype: "image/png",
  },
  {
    id: "file-98982721774108",
    url: rooturl + "library/Oklar/ok6.png",
    name: "Pembe Ok2",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok, noktalı, dotted",
    mimetype: "image/png",
  },
  {
    id: "file-4326701392583",
    url: rooturl + "library/Oklar/ok7.png",
    name: "Mavi Ok3",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-34767256189589",
    url: rooturl + "library/Oklar/ok8.png",
    name: "Sarı Ok2",
    keywords: "sarı,turuncu,ok,sarı ok,turuncu ok,yellow,orange,yellow arrow,orange arrow,arrow",
    mimetype: "image/png",
  },
  {
    id: "file-74219183144023",
    url: rooturl + "library/Oklar/ok9.png",
    name: "Mor Ok",
    keywords: "mor,ok, purple,arrow,mor ok,purple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-1693785345707",
    url: rooturl + "library/Oklar/ok10.png",
    name: "Yeşil Ok2",
    keywords: "yeşil,ok,green,arrow, yeşil ok, green arrow",
    mimetype: "image/png",
  },
  {
    id: "file-43075403127614",
    url: rooturl + "library/Oklar/ok11.png",
    name: "Mor Ok",
    keywords: "mor,ok, purple,arrow,mor ok,purple arrow,çift,çift ok,double,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-16564258215040",
    url: rooturl + "library/Oklar/ok12.png",
    name: "Sarı Ok",
    keywords:
      "sarı,turuncu,ok,sarı ok,turuncu ok,yellow,orange,yellow arrow,orange arrow,arrow,noktalı,dotted,çift,çift ok,double,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-7619792278609",
    url: rooturl + "library/Oklar/ok13.png",
    name: "Yeşil Ok",
    keywords: "yeşil,ok,green,arrow, yeşil ok, green arrow,çift,çift ok,double,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-34132059611098",
    url: rooturl + "library/Oklar/ok14.png",
    name: "Mavi Ok",
    keywords:
      "mavi,ok,blue,arrow,blue arrow, mavi ok,noktalı,dotted,çift,çift ok,double,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-91605971594891",
    url: rooturl + "library/Oklar/ok15.png",
    name: "Pembe Ok",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok, çift,çift ok,double,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-83387651594629",
    url: rooturl + "library/Oklar/ok16.png",
    name: "Sarı Ok",
    keywords: "sarı,turuncu,ok,sarı ok,turuncu ok,yellow,orange,yellow arrow,orange arrow,arrow",
    mimetype: "image/png",
  },
  {
    id: "file-60194041317937",
    url: rooturl + "library/Oklar/ok17.png",
    name: "Pembe Ok",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok",
    mimetype: "image/png",
  },
  {
    id: "file-43056032418293",
    url: rooturl + "library/Oklar/ok18.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-80454617865550",
    url: rooturl + "library/Oklar/ok19.png",
    name: "Mor Ok",
    keywords: "mor,ok, purple,arrow,mor ok,purple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-6522053670828",
    url: rooturl + "library/Oklar/ok20.png",
    name: "Yeşil Ok",
    keywords: "yeşil,ok,green,arrow, yeşil ok, green arrow",
    mimetype: "image/png",
  },
  {
    id: "file-53745178800679",
    url: rooturl + "library/Oklar/ok21.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok,ileri,next,ileri ok, next arrow",
    mimetype: "image/png",
  },
  {
    id: "file-77962735728254",
    url: rooturl + "library/Oklar/ok22.png",
    name: "Yeşil Ok",
    keywords: "yeşil,ok,green,arrow, yeşil ok, green arrow",
    mimetype: "image/png",
  },
  {
    id: "file-39775677603771",
    url: rooturl + "library/Oklar/ok23.png",
    name: "Sarı Ok",
    keywords:
      "sarı,turuncu,ok,sarı ok,turuncu ok,yellow,orange,yellow arrow,orange arrow,arrow,çift,çift ok,double,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-27558296656866",
    url: rooturl + "library/Oklar/ok24.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok,ileri,next,ileri ok, next arrow",
    mimetype: "image/png",
  },
  {
    id: "file-37644903889842",
    url: rooturl + "library/Oklar/ok25.png",
    name: "Pembe Ok",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok, tekrar,replay",
    mimetype: "image/png",
  },
  {
    id: "file-87285275854904",
    url: rooturl + "library/Oklar/ok26.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-18641346565169",
    url: rooturl + "library/Oklar/ok27.png",
    name: "Renkli Ok",
    keywords: "renkli,ok,renkli ok,colorful,arrow,colorful arrow",
    mimetype: "image/png",
  },
  {
    id: "file-45112002935563",
    url: rooturl + "library/Oklar/ok28.png",
    name: "Renkli Ok",
    keywords: "renkli,ok,renkli ok,colorful,arrow,colorful arrow",
    mimetype: "image/png",
  },
  {
    id: "file-96097281790248",
    url: rooturl + "library/Oklar/ok29.png",
    name: "Beyaz Ok",
    keywords: "beyaz,ok,beyaz ok,white,arrow,white arrow,kırmızı,red,yuvarlak,circle,round,daire",
    mimetype: "image/png",
  },
  {
    id: "file-36697622421481",
    url: rooturl + "library/Oklar/ok30.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-20612963699571",
    url: rooturl + "library/Oklar/ok31.png",
    name: "Renkli Ok",
    keywords: "renkli,ok,renkli ok,colorful,arrow,colorful arrow",
    mimetype: "image/png",
  },
  {
    id: "file-30211587253285",
    url: rooturl + "library/Oklar/ok32.png",
    name: "Pembe Ok",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok",
    mimetype: "image/png",
  },
  {
    id: "file-5970760192765",
    url: rooturl + "library/Oklar/ok33.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok,sarı,yellow,kare,square",
    mimetype: "image/png",
  },
  {
    id: "file-64659558552417",
    url: rooturl + "library/Oklar/ok34.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok,çoklu,çoklu ok,multiple,multiple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-2762845714641",
    url: rooturl + "library/Oklar/ok35.png",
    name: "Renkli Ok",
    keywords:
      "renkli,ok,renkli ok,colorful,arrow,colorful arrow,çoklu,çoklu ok,multiple,multiple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-46105828426294",
    url: rooturl + "library/Oklar/ok36.png",
    name: "Sarı Ok",
    keywords:
      "sarı,turuncu,ok,sarı ok,turuncu ok,yellow,orange,yellow arrow,orange arrow,arrow,geri,geri ok,back,back arrow",
    mimetype: "image/png",
  },
  {
    id: "file-357629085317",
    url: rooturl + "library/Oklar/ok37.png",
    name: "Renkli Ok",
    keywords:
      "renkli,ok,renkli ok,colorful,arrow,colorful arrow,çoklu,çoklu ok,multiple,multiple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-71137901668438",
    url: rooturl + "library/Oklar/ok38.png",
    name: "Renkli Ok",
    keywords:
      "renkli,ok,renkli ok,colorful,arrow,colorful arrow,çoklu,çoklu ok,multiple,multiple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-6143846908352",
    url: rooturl + "library/Oklar/ok39.png",
    name: "Mavi Ok",
    keywords:
      "mavi,ok,blue,arrow,blue arrow, mavi ok,çoklu,çoklu ok,multiple,multiple arrow,çift,çift ok,double,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-38343183877349",
    url: rooturl + "library/Oklar/ok40.png",
    name: "Renkli Ok",
    keywords:
      "renkli,ok,renkli ok,colorful,arrow,colorful arrow,çoklu,çoklu ok,multiple,multiple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-6953522401318",
    url: rooturl + "library/Oklar/ok41.png",
    name: "Sarı Ok",
    keywords: "sarı,turuncu,ok,sarı ok,turuncu ok,yellow,orange,yellow arrow,orange arrow,arrow",
    mimetype: "image/png",
  },
  {
    id: "file-6575247645402",
    url: rooturl + "library/Oklar/ok42.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok,tekrar,replay",
    mimetype: "image/png",
  },
  {
    id: "file-7415101227334",
    url: rooturl + "library/Oklar/ok43.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok,sarı,yellow,kare,square",
    mimetype: "image/png",
  },
  {
    id: "file-40852506261158",
    url: rooturl + "library/Oklar/ok44.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok,çoklu,çoklu ok,multiple,multiple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-28940286099892",
    url: rooturl + "library/Oklar/ok45.png",
    name: "Kırmızı Ok",
    keywords: "ok,arrow,play,oynatma,kırmızı,red,yuvarlak,circle,round,daire,red arrow,kırmızı ok",
    mimetype: "image/png",
  },
  {
    id: "file-47231979825100",
    url: rooturl + "library/Oklar/ok46.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok,çoklu,çoklu ok,multiple,multiple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-8274283533569",
    url: rooturl + "library/Oklar/ok47.png",
    name: "Sarı Ok",
    keywords:
      "sarı,turuncu,ok,sarı ok,turuncu ok,yellow,orange,yellow arrow,orange arrow,arrow,yuvarlak,circle,round,daire",
    mimetype: "image/png",
  },
  {
    id: "file-57100835031054",
    url: rooturl + "library/Oklar/ok48.png",
    name: "Renkli Ok",
    keywords:
      "renkli,ok,renkli ok,colorful,arrow,colorful arrow,çoklu,çoklu ok,multiple,multiple arrow,yön,yön okları, direction, direction arrow",
    mimetype: "image/png",
  },
  {
    id: "file-70602018542225",
    url: rooturl + "library/Oklar/ok49.png",
    name: "Kırmızı Ok",
    keywords: "ok,arrow,kırmızı,red,red arrow, kırmızı ok",
    mimetype: "image/png",
  },
  {
    id: "file-19372639515175",
    url: rooturl + "library/Oklar/ok50.png",
    name: "Kırmızı Ok",
    keywords: "ok,arrow,kırmızı,red,red arrow, kırmızı ok,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-17709912549733",
    url: rooturl + "library/Oklar/ok51.png",
    name: "Renkli Ok",
    keywords: "renkli,ok,renkli ok,colorful,arrow,colorful arrow",
    mimetype: "image/png",
  },
  {
    id: "file-12528248912424",
    url: rooturl + "library/Oklar/ok52.png",
    name: "Kırmızı Ok",
    keywords: "ok,arrow,kırmızı,red,red arrow, kırmızı ok,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-75197138816924",
    url: rooturl + "library/Oklar/ok53.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-28170237094433",
    url: rooturl + "library/Oklar/ok54.png",
    name: "Pembe Ok",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok",
    mimetype: "image/png",
  },
  {
    id: "file-62318725576763",
    url: rooturl + "library/Oklar/ok55.png",
    name: "Sarı Ok",
    keywords:
      "sarı,turuncu,ok,sarı ok,turuncu ok,yellow,orange,yellow arrow,orange arrow,arrow,noktalı,dotted",
    mimetype: "image/png",
  },
  {
    id: "file-70004392841157",
    url: rooturl + "library/Oklar/ok56.png",
    name: "Renkli Ok",
    keywords: "renkli,ok,renkli ok,colorful,arrow,colorful arrow",
    mimetype: "image/png",
  },
  {
    id: "file-99669035062991",
    url: rooturl + "library/Oklar/ok57.png",
    name: "Sarı Ok",
    keywords: "sarı,turuncu,ok,sarı ok,turuncu ok,yellow,orange,yellow arrow,orange arrow,arrow",
    mimetype: "image/png",
  },
  {
    id: "file-84424726000129",
    url: rooturl + "library/Oklar/ok58.png",
    name: "Kırmızı Ok",
    keywords: "ok,arrow,kırmızı,red,red arrow, kırmızı ok",
    mimetype: "image/png",
  },
  {
    id: "file-89198799427284",
    url: rooturl + "library/Oklar/ok59.png",
    name: "Pembe Ok",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok",
    mimetype: "image/png",
  },
  {
    id: "file-86105337508539",
    url: rooturl + "library/Oklar/ok60.png",
    name: "Renkli Ok",
    keywords: "renkli,ok,renkli ok,colorful,arrow,colorful arrow,noktalı,dotted",
    mimetype: "image/png",
  },
  {
    id: "file-84201169440904",
    url: rooturl + "library/Oklar/ok61.png",
    name: "Beyaz Ok",
    keywords: "beyaz,ok,beyaz ok,white,arrow,white arrow,kırmızı,red,kare,square",
    mimetype: "image/png",
  },
  {
    id: "file-758295503113",
    url: rooturl + "library/Oklar/ok62.png",
    name: "Sarı Ok",
    keywords: "sarı,turuncu,ok,sarı ok,turuncu ok,yellow,orange,yellow arrow,orange arrow,arrow",
    mimetype: "image/png",
  },
  {
    id: "file-1870457784237",
    url: rooturl + "library/Oklar/ok63.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-24007755716582",
    url: rooturl + "library/Oklar/ok64.png",
    name: "Renkli Ok",
    keywords: "renkli,ok,renkli ok,colorful,arrow,colorful arrow,noktalı,dotted",
    mimetype: "image/png",
  },
  {
    id: "file-32810155583572",
    url: rooturl + "library/Oklar/ok65.png",
    name: "Renkli Ok",
    keywords: "renkli,ok,renkli ok,colorful,arrow,colorful arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-78483212042568",
    url: rooturl + "library/Oklar/ok66.png",
    name: "Gri Ok",
    keywords: "Gri,ok,grey,arrow,gri ok,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-3918842175986",
    url: rooturl + "library/Oklar/ok67.png",
    name: "Pembe Ok",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok",
    mimetype: "image/png",
  },
  {
    id: "file-61131386821509",
    url: rooturl + "library/Oklar/ok68.png",
    name: "Pembe Ok",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok",
    mimetype: "image/png",
  },
  {
    id: "file-90240039630179",
    url: rooturl + "library/Oklar/ok69.png",
    name: "Renkli Ok",
    keywords: "renkli,ok,renkli ok,colorful,arrow,colorful arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-23075999093888",
    url: rooturl + "library/Oklar/ok70.png",
    name: "Gri Ok",
    keywords: "Gri,ok,grey,arrow,gri ok,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-96997927705421",
    url: rooturl + "library/Oklar/ok71.png",
    name: "Kırmızı Ok",
    keywords: "ok,arrow,kırmızı,red,red arrow, kırmızı ok",
    mimetype: "image/png",
  },
  {
    id: "file-10695278304621",
    url: rooturl + "library/Oklar/ok72.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-29546891366085",
    url: rooturl + "library/Oklar/ok73.png",
    name: "Kırmızı Ok",
    keywords: "ok,arrow,kırmızı,red,red arrow, kırmızı ok,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-19614491023717",
    url: rooturl + "library/Oklar/ok74.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-95637959715894",
    url: rooturl + "library/Oklar/ok75.png",
    name: "Sarı Ok",
    keywords:
      "sarı,turuncu,ok,sarı ok,turuncu ok,yellow,orange,yellow arrow,orange arrow,arrow,noktalı,dotted",
    mimetype: "image/png",
  },
  {
    id: "file-44823498806777",
    url: rooturl + "library/Oklar/ok76.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok,ileri,next,ileri ok, next arrow",
    mimetype: "image/png",
  },
  {
    id: "file-87686691694897",
    url: rooturl + "library/Oklar/ok77.png",
    name: "Renkli Ok",
    keywords: "renkli,ok,renkli ok,colorful,arrow,colorful arrow",
    mimetype: "image/png",
  },
  {
    id: "file-31453469356540",
    url: rooturl + "library/Oklar/ok78.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-53352369108481",
    url: rooturl + "library/Oklar/ok79.png",
    name: "Renkli Ok",
    keywords: "renkli,ok,renkli ok,colorful,arrow,colorful arrow,noktalı,dotted",
    mimetype: "image/png",
  },
  {
    id: "file-8389465819112",
    url: rooturl + "library/Oklar/ok80.png",
    name: "Kırmızı Ok",
    keywords:
      "ok,arrow,kırmızı,red,red arrow, kırmızı ok,çift,double,çift ok,double arrow,tekrar,replay",
    mimetype: "image/png",
  },
  {
    id: "file-16900088165140",
    url: rooturl + "library/Oklar/ok81.png",
    name: "Sarı Ok",
    keywords: "sarı,turuncu,ok,sarı ok,turuncu ok,yellow,orange,yellow arrow,orange arrow,arrow",
    mimetype: "image/png",
  },
  {
    id: "file-33929308343977",
    url: rooturl + "library/Oklar/ok82.png",
    name: "Mor Ok",
    keywords: "mor,ok, purple,arrow,mor ok,purple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-44190051344808",
    url: rooturl + "library/Oklar/ok83.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-81896951209989",
    url: rooturl + "library/Oklar/ok84.png",
    name: "Mor Ok",
    keywords: "mor,ok, purple,arrow,mor ok,purple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-54362596480109",
    url: rooturl + "library/Oklar/ok85.png",
    name: "Yeşil Ok",
    keywords: "yeşil,ok,green,arrow, yeşil ok, green arrow",
    mimetype: "image/png",
  },
  {
    id: "file-71638502293074",
    url: rooturl + "library/Oklar/ok86.png",
    name: "Pembe Ok",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-38311047011950",
    url: rooturl + "library/Oklar/ok87.png",
    name: "Yeşil Ok",
    keywords: "yeşil,ok,green,arrow, yeşil ok, green arrow",
    mimetype: "image/png",
  },
  {
    id: "file-13874943396657",
    url: rooturl + "library/Oklar/ok88.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-32837601268456",
    url: rooturl + "library/Oklar/ok89.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-2447102851127",
    url: rooturl + "library/Oklar/ok90.png",
    name: "Turuncu Ok",
    keywords: "turuncu,ok,turuncu ok,orange,orange arrow,arrow",
    mimetype: "image/png",
  },
  {
    id: "file-41632381885198",
    url: rooturl + "library/Oklar/ok91.png",
    name: "Sarı Ok",
    keywords:
      "sarı,turuncu,ok,sarı ok,turuncu ok,yellow,orange,yellow arrow,orange arrow,arrow,çoklu,çoklu ok,multiple,multiple arrow,yön,yön okları, direction, direction arrow",
    mimetype: "image/png",
  },
  {
    id: "file-11749242460321",
    url: rooturl + "library/Oklar/ok92.png",
    name: "Pembe Ok",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok",
    mimetype: "image/png",
  },
  {
    id: "file-55308885552236",
    url: rooturl + "library/Oklar/ok93.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-5655736397861",
    url: rooturl + "library/Oklar/ok94.png",
    name: "Yeşil Ok",
    keywords: "yeşil,ok,green,arrow, yeşil ok, green arrow,tekrar,replay",
    mimetype: "image/png",
  },
  {
    id: "file-7876554040147",
    url: rooturl + "library/Oklar/ok95.png",
    name: "Kırmızı Ok",
    keywords:
      "ok,arrow,kırmızı,red,red arrow, kırmızı ok,geri.back,geri ok,back arrow,yuvarlak,circile,daire,round",
    mimetype: "image/png",
  },
  {
    id: "file-62062387783435",
    url: rooturl + "library/Oklar/ok96.png",
    name: "Pembe Ok",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok",
    mimetype: "image/png",
  },
  {
    id: "file-18163671552381",
    url: rooturl + "library/Oklar/ok97.png",
    name: "Sarı Ok",
    keywords: "sarı,ok,sarı ok,yellow,yellow arrow,arrow,çift,çift ok,double,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-38414559091382",
    url: rooturl + "library/Oklar/ok98.png",
    name: "Kırmızı Ok",
    keywords: "ok,arrow,kırmızı,red,red arrow, kırmızı ok",
    mimetype: "image/png",
  },
  {
    id: "file-49939238698030",
    url: rooturl + "library/Oklar/ok99.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-75304642035275",
    url: rooturl + "library/Oklar/ok100.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-24140915353332",
    url: rooturl + "library/Oklar/ok101.png",
    name: "Pembe Ok",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok,çoklu,multiple,çoklu ok,multiple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-54142057265642",
    url: rooturl + "library/Oklar/ok102.png",
    name: "Sarı Ok",
    keywords: "sarı,ok,sarı ok,yellow,yellow arrow,arrow",
    mimetype: "image/png",
  },
  {
    id: "file-60820186885782",
    url: rooturl + "library/Oklar/ok103.png",
    name: "Kırmızı Ok",
    keywords: "ok,arrow,kırmızı,red,red arrow, kırmızı ok",
    mimetype: "image/png",
  },
  {
    id: "file-43687387665103",
    url: rooturl + "library/Oklar/ok104.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-84251332583396",
    url: rooturl + "library/Oklar/ok105.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-1976685630354",
    url: rooturl + "library/Oklar/ok106.png",
    name: "Pembe Ok",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok",
    mimetype: "image/png",
  },
  {
    id: "file-16444176296158",
    url: rooturl + "library/Oklar/ok107.png",
    name: "Sarı Ok",
    keywords: "sarı,ok,sarı ok,yellow,yellow arrow,arrow",
    mimetype: "image/png",
  },
  {
    id: "file-60917646162036",
    url: rooturl + "library/Oklar/ok108.png",
    name: "Kırmızı Ok",
    keywords: "ok,arrow,kırmızı,red,red arrow, kırmızı ok,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-4207741688205",
    url: rooturl + "library/Oklar/ok109.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-66136661958028",
    url: rooturl + "library/Oklar/ok110.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-7742678948308",
    url: rooturl + "library/Oklar/ok111.png",
    name: "Pembe Ok",
    keywords: "pembe,ok,pink,arrow,pink arrow,pembe ok",
    mimetype: "image/png",
  },
  {
    id: "file-10316774389214",
    url: rooturl + "library/Oklar/ok112.png",
    name: "Sarı Ok",
    keywords: "sarı,ok,sarı ok,yellow,yellow arrow,arrow",
    mimetype: "image/png",
  },
  {
    id: "file-83849262302560",
    url: rooturl + "library/Oklar/ok113.png",
    name: "Kırmızı Ok",
    keywords: "ok,arrow,kırmızı,red,red arrow, kırmızı ok,çoklu,multiple,çoklu ok,multiple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-98302347028937",
    url: rooturl + "library/Oklar/ok114.png",
    name: "Mavi Ok",
    keywords: "mavi,ok,blue,arrow,blue arrow, mavi ok",
    mimetype: "image/png",
  },
  {
    id: "file-59187225671491",
    url: rooturl + "library/Oklar/ok115.png",
    name: "Kırmızı Ok",
    keywords: "ok,arrow,kırmızı,red,red arrow, kırmızı ok,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-42278529790519",
    url: rooturl + "library/Oklar/ok118.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-22926559852685",
    url: rooturl + "library/Oklar/ok120.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,indirme,kaydetme,download,save",
    mimetype: "image/png",
  },
  {
    id: "file-60625883573093",
    url: rooturl + "library/Oklar/ok121.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,yükleme,gönderme,send,upload",
    mimetype: "image/png",
  },
  {
    id: "file-87555178476788",
    url: rooturl + "library/Oklar/ok122.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-25150474706970",
    url: rooturl + "library/Oklar/ok123.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-70585059111122",
    url: rooturl + "library/Oklar/ok124.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-26878332490525",
    url: rooturl + "library/Oklar/ok125.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-82254738957564",
    url: rooturl + "library/Oklar/ok126.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-1161127739678",
    url: rooturl + "library/Oklar/ok127.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-86782193400498",
    url: rooturl + "library/Oklar/ok129.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-81639236580324",
    url: rooturl + "library/Oklar/ok130.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-91178283211393",
    url: rooturl + "library/Oklar/ok131.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-6252348140",
    url: rooturl + "library/Oklar/ok132.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-51163053927409",
    url: rooturl + "library/Oklar/ok135.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,tekrar,replay",
    mimetype: "image/png",
  },
  {
    id: "file-30682277131038",
    url: rooturl + "library/Oklar/ok137.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,indirme,kaydetme,download,save",
    mimetype: "image/png",
  },
  {
    id: "file-2910815110929",
    url: rooturl + "library/Oklar/ok138.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,yükleme,gönderme,send,upload",
    mimetype: "image/png",
  },
  {
    id: "file-44669561145282",
    url: rooturl + "library/Oklar/ok145.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-28408779794525",
    url: rooturl + "library/Oklar/ok146.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-32566044090500",
    url: rooturl + "library/Oklar/ok149.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-68573673303270",
    url: rooturl + "library/Oklar/ok150.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-16996197713397",
    url: rooturl + "library/Oklar/ok153.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-22337367907378",
    url: rooturl + "library/Oklar/ok155.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-62875899796989",
    url: rooturl + "library/Oklar/ok160.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-74294108833310",
    url: rooturl + "library/Oklar/ok165.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-21793676978665",
    url: rooturl + "library/Oklar/ok168.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-9576957366533",
    url: rooturl + "library/Oklar/ok169.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-8481574977431",
    url: rooturl + "library/Oklar/ok170.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-3173133308209",
    url: rooturl + "library/Oklar/ok171.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-62001717508560",
    url: rooturl + "library/Oklar/ok172.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-74538304292249",
    url: rooturl + "library/Oklar/ok173.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-72627279514906",
    url: rooturl + "library/Oklar/ok174.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-91531881167374",
    url: rooturl + "library/Oklar/ok175.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-41798216700218",
    url: rooturl + "library/Oklar/ok176.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-72666262970970",
    url: rooturl + "library/Oklar/ok177.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-27745192938390",
    url: rooturl + "library/Oklar/ok178.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-68379719477886",
    url: rooturl + "library/Oklar/ok179.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-24391583210330",
    url: rooturl + "library/Oklar/ok180.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-2225290885964",
    url: rooturl + "library/Oklar/ok181.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-65291824019309",
    url: rooturl + "library/Oklar/ok182.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-6283464187422",
    url: rooturl + "library/Oklar/ok183.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-74732129903303",
    url: rooturl + "library/Oklar/ok184.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-52409867683081",
    url: rooturl + "library/Oklar/ok185.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-69826106736041",
    url: rooturl + "library/Oklar/ok186.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-25897787772840",
    url: rooturl + "library/Oklar/ok187.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-85641438124831",
    url: rooturl + "library/Oklar/ok188.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-7305712832890",
    url: rooturl + "library/Oklar/ok189.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-45892548719578",
    url: rooturl + "library/Oklar/ok190.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-40382746962130",
    url: rooturl + "library/Oklar/ok191.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-2543083123223",
    url: rooturl + "library/Oklar/ok192.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-26183945024829",
    url: rooturl + "library/Oklar/ok193.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-96292184352279",
    url: rooturl + "library/Oklar/ok194.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-62827482657617",
    url: rooturl + "library/Oklar/ok195.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-86606576572452",
    url: rooturl + "library/Oklar/ok196.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-12697248610599",
    url: rooturl + "library/Oklar/ok197.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çoklu,multiple,çoklu ok,multiple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-18343284901467",
    url: rooturl + "library/Oklar/ok198.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çoklu,multiple,çoklu ok,multiple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-7963532734704",
    url: rooturl + "library/Oklar/ok199.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,çoklu,multiple,çoklu ok,multiple arrow",
    mimetype: "image/png",
  },
  {
    id: "file-55114014079967",
    url: rooturl + "library/Oklar/ok200.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-26106501788297",
    url: rooturl + "library/Oklar/ok201.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-17926645804268",
    url: rooturl + "library/Oklar/ok202.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-19581027405024",
    url: rooturl + "library/Oklar/ok203.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-5212875117111",
    url: rooturl + "library/Oklar/ok204.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-62963955342780",
    url: rooturl + "library/Oklar/ok205.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-67326347394030",
    url: rooturl + "library/Oklar/ok206.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-75864738644866",
    url: rooturl + "library/Oklar/ok207.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-52734966011790",
    url: rooturl + "library/Oklar/ok208.png",
    name: "Siyah Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow",
    mimetype: "image/png",
  },
  {
    id: "file-49589092658931",
    url: rooturl + "library/Oklar/ok209.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-46115984858050",
    url: rooturl + "library/Oklar/ok210.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-98113527373010",
    url: rooturl + "library/Oklar/ok211.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-4491558801810",
    url: rooturl + "library/Oklar/ok212.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-37015099998728",
    url: rooturl + "library/Oklar/ok213.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-28986716820107",
    url: rooturl + "library/Oklar/ok214.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-21236121083692",
    url: rooturl + "library/Oklar/ok215.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-75539924209137",
    url: rooturl + "library/Oklar/ok216.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-87543619810328",
    url: rooturl + "library/Oklar/ok217.png",
    name: "Gri Ok",
    keywords:
      "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-77334945272771",
    url: rooturl + "library/Oklar/ok218.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-601929360351",
    url: rooturl + "library/Oklar/ok219.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-96576385624414",
    url: rooturl + "library/Oklar/ok220.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-36744306325194",
    url: rooturl + "library/Oklar/ok221.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-20910685409057",
    url: rooturl + "library/Oklar/ok222.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-96053412418464",
    url: rooturl + "library/Oklar/ok223.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-24753892890840",
    url: rooturl + "library/Oklar/ok224.png",
    name: "Gri Ok",
    keywords:
      "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-74731562029381",
    url: rooturl + "library/Oklar/ok225.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-50475305818244",
    url: rooturl + "library/Oklar/ok226.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-28112672134757",
    url: rooturl + "library/Oklar/ok227.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-66038813305681",
    url: rooturl + "library/Oklar/ok228.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-19708452849336",
    url: rooturl + "library/Oklar/ok229.png",
    name: "Gri Ok",
    keywords:
      "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-62242826168927",
    url: rooturl + "library/Oklar/ok230.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-61186876327068",
    url: rooturl + "library/Oklar/ok231.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-64398444995549",
    url: rooturl + "library/Oklar/ok232.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-55250797847333",
    url: rooturl + "library/Oklar/ok233.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-65529824853485",
    url: rooturl + "library/Oklar/ok234.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-71400249347682",
    url: rooturl + "library/Oklar/ok235.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-36442523989390",
    url: rooturl + "library/Oklar/ok236.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },
  {
    id: "file-35719807686656",
    url: rooturl + "library/Oklar/ok237.png",
    name: "Gri Ok",
    keywords:
      "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow,çift,double,çift ok,double arrow",
    mimetype: "image/png",
  },
  {
    id: "file-64952969893788",
    url: rooturl + "library/Oklar/ok238.png",
    name: "Gri Ok",
    keywords: "siyah,ok,black,arrow,siyah ok,black arrow,gri,gri ok,grey,grey arrow",
    mimetype: "image/png",
  },

  // Balonlar

  {
    id: "file-18068829266779",
    url: rooturl + "library/Balonlar/konusmabalonu1.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,sarı,sarı konuşma balonu,sarı balon,turuncu konuşma balonu,turuncu balon,yellow talking baloon,talking baloon,speech baloon,yellow,orange,yellow speech baloon,orange talking baloon,orange speech baloon,bubble,speech bubble,talking bubble,yellow talking bubble,yellow speech bubble,orange talking bubble,orange speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-77260845930097",
    url: rooturl + "library/Balonlar/konusmabalonu2.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,yeşil,yeşil konuşma balonu,yeşil balon,patlama,green,green talking baloon,talking baloon,speech baloon,green speech baloon,bubble,speech bubble,talking bubble,green talking bubble,green speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-6226986311628",
    url: rooturl + "library/Balonlar/konusmabalonu3.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,mavi,mavi konuşma balonu,mavi balon,blue,blue talking baloon,talking baloon,speech baloon,blue speech baloon,bubble,speech bubble,talking bubble,blue talking bubble blue speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-30282699286681",
    url: rooturl + "library/Balonlar/konusmabalonu4.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,yeşil,yeşil konuşma balonu,yeşil balon,green,green talking baloon,talking baloon,speech baloon,green speech baloon,bubble,speech bubble,talking bubble,green talking bubble,green speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-42767296303188",
    url: rooturl + "library/Balonlar/konusmabalonu5.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,kırmızı,kırmızı konuşma balonu,kırmızı balon,red,red talking baloon,talking baloon,speech baloon,red speech baloon,bubble,speech bubble,talking bubble,red talking bubble,red speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-24616163006893",
    url: rooturl + "library/Balonlar/konusmabalonu6.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,sarı,sarı konuşma balonu,sarı balon,turuncu konuşma balonu,turuncu balon,yellow talking baloon,talking baloon,speech baloon,yellow,orange,yellow speech baloon,orange talking baloon,orange speech baloon,bubble,speech bubble,talking bubble,yellow talking bubble,yellow speech bubble,orange talking bubble,orange speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-52279773632207",
    url: rooturl + "library/Balonlar/konusmabalonu7.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,pembe,pembe konuşma balonu,pembe balon,pink,pink talking baloon,talking baloon,speech baloon,pink speech baloon,bubble,speech bubble,talking bubble,pink talking bubble,pink speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-65210384776266",
    url: rooturl + "library/Balonlar/konusmabalonu8.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,mavi,mavi konuşma balonu,mavi balon,blue,blue talking baloon,talking baloon,speech baloon,blue speech baloon,bubble,speech bubble,talking bubble,blue talking bubble blue speech bubble,bulut,cloud,mavi bulut,blue cloud",
    mimetype: "image/png",
  },
  {
    id: "file-87356547139236",
    url: rooturl + "library/Balonlar/konusmabalonu9.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,sarı,sarı konuşma balonu,sarı balon,turuncu konuşma balonu,turuncu balon,yellow talking baloon,talking baloon,speech baloon,yellow,orange,yellow speech baloon,orange talking baloon,orange speech baloon,bubble,speech bubble,talking bubble,yellow talking bubble,yellow speech bubble,orange talking bubble,orange speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-87975177324216",
    url: rooturl + "library/Balonlar/konusmabalonu10.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,kırmızı,kırmızı konuşma balonu,kırmızı balon,red,red talking baloon,talking baloon,speech baloon,red speech baloon,bubble,speech bubble,talking bubble,red talking bubble,red speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-75661167847366",
    url: rooturl + "library/Balonlar/konusmabalonu11.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,sarı,sarı konuşma balonu,sarı balon,turuncu konuşma balonu,turuncu balon,yellow talking baloon,talking baloon,speech baloon,yellow,orange,yellow speech baloon,orange talking baloon,orange speech baloon,bubble,speech bubble,talking bubble,yellow talking bubble,yellow speech bubble,orange talking bubble,orange speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-70659227235895",
    url: rooturl + "library/Balonlar/konusmabalonu12.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,yeşil,yeşil konuşma balonu,yeşil balon,green,green talking baloon,talking baloon,speech baloon,green speech baloon,bubble,speech bubble,talking bubble,green talking bubble,green speech bubble,buluticloud,yeşil bulut,green cloud",
    mimetype: "image/png",
  },
  {
    id: "file-93409764502034",
    url: rooturl + "library/Balonlar/konusmabalonu13.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,pembe,pembe konuşma balonu,pembe balon,pink,pink talking baloon,talking baloon,speech baloon,pink speech baloon,bubble,speech bubble,talking bubble,pink talking bubble,pink speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-23673177640084",
    url: rooturl + "library/Balonlar/konusmabalonu14.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,mavi,mavi konuşma balonu,mavi balon,blue,blue talking baloon,talking baloon,speech baloon,blue speech baloon,bubble,speech bubble,talking bubble,blue talking bubble blue speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-33489445154251",
    url: rooturl + "library/Balonlar/konusmabalonu15.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,yeşil,yeşil konuşma balonu,yeşil balon,patlama,green,green talking baloon,talking baloon,speech baloon,green speech baloon,bubble,speech bubble,talking bubble,green talking bubble,green speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-10141812194105",
    url: rooturl + "library/Balonlar/konusmabalonu16.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,pembe,pembe konuşma balonu,pembe balon,pink,pink talking baloon,talking baloon,speech baloon,pink speech baloon,bubble,speech bubble,talking bubble,pink talking bubble,pink speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-22631962130580",
    url: rooturl + "library/Balonlar/konusmabalonu17.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,kırmızı,kırmızı konuşma balonu,kırmızı balon,red,red talking baloon,talking baloon,speech baloon,red speech baloon,bubble,speech bubble,talking bubble,red talking bubble,red speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-3386626299125",
    url: rooturl + "library/Balonlar/konusmabalonu18.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,pembe,pembe konuşma balonu,pembe balon,pink,pink talking baloon,talking baloon,speech baloon,pink speech baloon,bubble,speech bubble,talking bubble,pink talking bubble,pink speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-24613647379071",
    url: rooturl + "library/Balonlar/konusmabalonu19.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,mavi,mavi konuşma balonu,mavi balon,blue,blue talking baloon,talking baloon,speech baloon,blue speech baloon,bubble,speech bubble,talking bubble,blue talking bubble blue speech bubble,bulut,cloud,mavi bulut,blue cloud",
    mimetype: "image/png",
  },
  {
    id: "file-90609348949002",
    url: rooturl + "library/Balonlar/konusmabalonu20.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,pembe,pembe konuşma balonu,pembe balon,pink,pink talking baloon,talking baloon,speech baloon,pink speech baloon,bubble,speech bubble,talking bubble,pink talking bubble,pink speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-9050514653861",
    url: rooturl + "library/Balonlar/konusmabalonu21.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,pembe,pembe konuşma balonu,pembe balon,pink,pink talking baloon,talking baloon,speech baloon,pink speech baloon,bubble,speech bubble,talking bubble,pink talking bubble,pink speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-92345130119",
    url: rooturl + "library/Balonlar/konusmabalonu22.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,mavi,mavi konuşma balonu,mavi balon,blue,blue talking baloon,talking baloon,speech baloon,blue speech baloon,bubble,speech bubble,talking bubble,blue talking bubble blue speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-47841771603261",
    url: rooturl + "library/Balonlar/konusmabalonu23.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,mavi,mavi konuşma balonu,mavi balon,blue,blue talking baloon,talking baloon,speech baloon,blue speech baloon,bubble,speech bubble,talking bubble,blue talking bubble blue speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-13546679436681",
    url: rooturl + "library/Balonlar/konusmabalonu24.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,kırmızı,kırmızı konuşma balonu,kırmızı balon,red,red talking baloon,talking baloon,speech baloon,red speech baloon,bubble,speech bubble,talking bubble,red talking bubble,red speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-8738577121281",
    url: rooturl + "library/Balonlar/konusmabalonu25.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-8237887217839",
    url: rooturl + "library/Balonlar/konusmabalonu26.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-5626289160021",
    url: rooturl + "library/Balonlar/konusmabalonu27.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-22405741631644",
    url: rooturl + "library/Balonlar/konusmabalonu28.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-5548824957691",
    url: rooturl + "library/Balonlar/konusmabalonu29.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-5055383857911",
    url: rooturl + "library/Balonlar/konusmabalonu30.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-21071979803573",
    url: rooturl + "library/Balonlar/konusmabalonu31.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-95261113207167",
    url: rooturl + "library/Balonlar/konusmabalonu32.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-69343702637841",
    url: rooturl + "library/Balonlar/konusmabalonu33.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-99147355224272",
    url: rooturl + "library/Balonlar/konusmabalonu34.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-60507547726001",
    url: rooturl + "library/Balonlar/konusmabalonu35.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-56457665015",
    url: rooturl + "library/Balonlar/konusmabalonu36.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-90998262410784",
    url: rooturl + "library/Balonlar/konusmabalonu37.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-15000721742701",
    url: rooturl + "library/Balonlar/konusmabalonu38.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-65856601406311",
    url: rooturl + "library/Balonlar/konusmabalonu39.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-97504328871059",
    url: rooturl + "library/Balonlar/konusmabalonu40.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-736562891094",
    url: rooturl + "library/Balonlar/konusmabalonu41.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-50738257912171",
    url: rooturl + "library/Balonlar/konusmabalonu42.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-42867643520901",
    url: rooturl + "library/Balonlar/konusmabalonu43.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-28771684306696",
    url: rooturl + "library/Balonlar/konusmabalonu44.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-7271501926802",
    url: rooturl + "library/Balonlar/konusmabalonu45.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-40431066710366",
    url: rooturl + "library/Balonlar/konusmabalonu46.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-96735077522312",
    url: rooturl + "library/Balonlar/konusmabalonu47.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-50466917143966",
    url: rooturl + "library/Balonlar/konusmabalonu48.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-48787091875883",
    url: rooturl + "library/Balonlar/konusmabalonu49.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-81618194380184",
    url: rooturl + "library/Balonlar/konusmabalonu50.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-59740898970098",
    url: rooturl + "library/Balonlar/konusmabalonu51.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-74872568475188",
    url: rooturl + "library/Balonlar/konusmabalonu52.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-29064878022500",
    url: rooturl + "library/Balonlar/konusmabalonu53.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-69706327514283",
    url: rooturl + "library/Balonlar/konusmabalonu54.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-13095865350098",
    url: rooturl + "library/Balonlar/konusmabalonu55.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-82587561558041",
    url: rooturl + "library/Balonlar/konusmabalonu56.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-87671091869128",
    url: rooturl + "library/Balonlar/konusmabalonu57.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-47622095969872",
    url: rooturl + "library/Balonlar/konusmabalonu58.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-77689514531674",
    url: rooturl + "library/Balonlar/konusmabalonu59.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-93659736928547",
    url: rooturl + "library/Balonlar/konusmabalonu60.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-8708769969763",
    url: rooturl + "library/Balonlar/konusmabalonu61.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-86306761184405",
    url: rooturl + "library/Balonlar/konusmabalonu62.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-49914349375212",
    url: rooturl + "library/Balonlar/konusmabalonu63.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-90458059884472",
    url: rooturl + "library/Balonlar/konusmabalonu64.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
  {
    id: "file-63056787290096",
    url: rooturl + "library/Balonlar/konusmabalonu65.png",
    name: "Konuşma Balonu",
    keywords:
      "konuşma,balon,konuşma balonu,beyaz,beyaz konuşma balonu,beyaz balon,white,white talking baloon,talking baloon,speech baloon,white speech baloon,bubble,speech bubble,talking bubble,white talking bubble,white speech bubble",
    mimetype: "image/png",
  },
];

function IconsPanel({
  onElementSelected,
  onBoxAdded,
  boxes,
  navItems,
  navItemSelected,
  containedViews,
  containedViewSelected,
  boxSelected,
  pluginToolbars,
  fileModalResult,
  onClose,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [hoveredId, setHoveredId] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);

  const filteredIcons = useMemo(() => {
    const q = searchTerm.trim().toLowerCase();
    if (!q) return ICONS;
    return ICONS.filter((icon) => {
      return (
        icon.name.toLowerCase().includes(q) ||
        (icon.keywords && icon.keywords.toLowerCase().includes(q))
      );
    });
  }, [searchTerm]);

  const handleIconDoubleClick = async (icon) => {
    const url = icon.url;

    const isReplaceMode = fileModalResult && fileModalResult.id;
    const acceptsImage =
      !fileModalResult?.accept || fileModalResult.accept.toLowerCase().includes("image");
    if (isReplaceMode && acceptsImage) {
      if (onElementSelected && url) onElementSelected(icon.name, url, "image", icon.id);
      return;
    }

    // Önce sahneye image kutusu ekle (HotspotImages) – MyFilesPanel'deki addFileAsBox mantığına benzer
    if (onBoxAdded && url && boxes && navItems && containedViews) {
      const pluginName = "HotspotImages";
      const plugin = IdealStudio.Plugins.get(pluginName);
      if (plugin) {
        const navItem =
          containedViewSelected && containedViews[containedViewSelected]
            ? containedViews[containedViewSelected]
            : navItems[navItemSelected];

        if (navItem) {
          const cv =
            containedViewSelected &&
            containedViews[containedViewSelected] &&
            isContainedView(containedViewSelected);
          const cvslide = cv && isSlide(navItem.type);
          const inASlide = (!cv && isSlide(navItem.type)) || cvslide;
          const parent = inASlide ? navItem.id : navItem.boxes && navItem.boxes[0];

          const { width, height, widthUnit, heightUnit } = await getMediaBoxSize(url, "image");

          const initialParams = {
            parent,
            container: 0,
            name: pluginName,
            position: {
              x: randomPositionGenerator(10, 30),
              y: randomPositionGenerator(10, 30),
              type: "absolute",
            },
            id: ID_PREFIX_BOX + Date.now(),
            page: cv ? containedViewSelected : navItem.id || navItemSelected || 0,
            url,
            width,
            height,
            widthUnit,
            heightUnit,
          };

          createBox(initialParams, pluginName, inASlide, onBoxAdded, boxes);
        }
      }
    }

    // Aynı zamanda modal davranışını da taklit et: ikon image olarak seçilsin
    if (onElementSelected) {
      onElementSelected(icon.name, icon.url, "image", icon.id);
    }
  };

  return (
    <div
      className="library-icons-panel"
      style={{
        flex: 1,
        padding: 12,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          marginBottom: 12,
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <input
          type="text"
          placeholder={i18n.t("search") || "Search"}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            flex: 1,
            height: 36,
            padding: "0 10px",
            borderRadius: 999,
            border: "1px solid #e5e7eb",
            outline: "none",
            fontSize: 13,
            backgroundColor: "#f9fafb",
          }}
        />
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            title={i18n.t("close") || "Kapat"}
            style={{
              flexShrink: 0,
              width: 24,
              height: 24,
              borderRadius: 999,
              border: "1px solid #e5e7eb",
              backgroundColor: "rgba(255,255,255,0.9)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <svg
              viewBox="0 0 24 24"
              width="14"
              height="14"
              stroke="#6b7280"
              strokeWidth="2.5"
              strokeLinecap="round"
              fill="none"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        )}
      </div>

      <div
        style={{
          flex: 1,
          overflowY: "auto",
          paddingRight: 4,
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(56px, 1fr))",
            gap: 8,
          }}
        >
          {filteredIcons.map((icon) => (
            <div
              key={icon.id}
              onMouseEnter={() => setHoveredId(icon.id)}
              onMouseLeave={() => setHoveredId(null)}
              style={{ position: "relative" }}
            >
              <div
                onClick={() =>
                  setPreviewFile({ id: icon.id, type: "image", url: icon.url, name: icon.name })
                }
                style={{
                  width: "100%",
                  aspectRatio: "1 / 1",
                  borderRadius: 8,
                  backgroundColor: "#f3f4f6",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.08)",
                  cursor: "zoom-in",
                  overflow: "hidden",
                }}
              >
                <img
                  src={icon.url}
                  alt={icon.name}
                  style={{
                    maxWidth: "80%",
                    maxHeight: "80%",
                    objectFit: "contain",
                  }}
                />
              </div>
              {hoveredId === icon.id && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleIconDoubleClick(icon);
                  }}
                  title={i18n.t("add_to_scene") || "Sahneye Ekle"}
                  style={{
                    position: "absolute",
                    bottom: 4,
                    right: 4,
                    width: 22,
                    height: 22,
                    borderRadius: 999,
                    border: "none",
                    backgroundColor: "rgba(99, 102, 241, 0.92)",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    fontSize: 18,
                    lineHeight: 1,
                    fontWeight: 500,
                    boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
                  }}
                >
                  +
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
      {previewFile && (
        <AppModal
          show
          onClose={() => setPreviewFile(null)}
          title={previewFile.name}
          centered
          size="lg"
          showSceneToggle={false}
          className="libraryPreviewModal"
        >
          <img
            src={previewFile.url}
            alt={previewFile.name}
            style={{
              width: "100%",
              maxHeight: "70vh",
              objectFit: "contain",
              borderRadius: 12,
              marginTop: 4,
              backgroundColor: "#f3f4f6",
            }}
          />
        </AppModal>
      )}
    </div>
  );
}

IconsPanel.propTypes = {
  onElementSelected: PropTypes.func,
  onBoxAdded: PropTypes.func,
  boxes: PropTypes.object,
  navItems: PropTypes.object,
  navItemSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  containedViews: PropTypes.object,
  containedViewSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  boxSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pluginToolbars: PropTypes.object,
  fileModalResult: PropTypes.object,
  onClose: PropTypes.func,
};

export default IconsPanel;
